import { useTranslation } from "react-i18next";
import { getAuthItems } from "../auth/AuthItems";
import { TenantPole } from "./AdminLoginApi";

export const LoginUserComponent = (): JSX.Element => {
  const { t } = useTranslation();

  const viewLoginPole = () => {
    switch (getAuthItems().loginPole) {
      case TenantPole.RE:
        return t("adminLogin.reTenantPole");
      case TenantPole.RJ:
        return t("adminLogin.rjTenantPole");
      case TenantPole.RUS:
        return t("adminLogin.rusTenantPole");
      case TenantPole.RLA:
        return t("adminLogin.rlaTenantPole");
      case TenantPole.RAP:
        return t("adminLogin.rapTenantPole");
      case TenantPole.RKR:
        return t("adminLogin.rkrTenantPole");
      default:
        return "";
    }
  };

  return (
    <>
      <div className="flex flex-row justify-end text-xl">
        <label>{`${t("adminLogin.countryOfCustomer")} : `}</label>
        <label>{viewLoginPole()}</label>
      </div>
    </>
  );
};
